import { gql } from '@apollo/client';

export const EDITABLE_DOCUMENT_FRAGMENT = gql`
  fragment EditableDocumentFragment on EditableDocumentType {
    id
    html
    version
    activeVersion
    confirmedAt
    lastEditedAt
    title
    lastViewedAt
    groupActiveVersionNumber
    isAutoGenerated
    isOutdated
  }
`;

export const GET_EDITABLE_DOCUMENT = gql`
  ${EDITABLE_DOCUMENT_FRAGMENT}
  query GetEditableDocument($editableDocumentVersionGroupId: ID!, $version: Int) {
    editableDocument(editableDocumentVersionGroupId: $editableDocumentVersionGroupId, version: $version) {
      ...EditableDocumentFragment
    }
  }
`;

export const GET_EDITABLE_DOCUMENT_VERSION_GROUP = gql`
  ${EDITABLE_DOCUMENT_FRAGMENT}
  query GetEditableDocumentVersionGroup(
    $documentId: ID
    $contentTypeAppLabel: String
    $contentTypeModel: String
    $objectId: Int
    $documentTemplateConfigId: ID
  ) {
    editableDocumentVersionGroup(
      documentId: $documentId
      contentTypeAppLabel: $contentTypeAppLabel
      contentTypeModel: $contentTypeModel
      objectId: $objectId
      documentTemplateConfigId: $documentTemplateConfigId
    ) {
      id
      editableDocument {
        ...EditableDocumentFragment
      }
    }
  }
`;

export const DISCARD_EDITABLE_DOCUMENT_VERSION = gql`
  ${EDITABLE_DOCUMENT_FRAGMENT}
  mutation DiscardEditableDocumentVersion($editableDocumentVersionGroupId: ID!) {
    discardEditableDocumentVersion(editableDocumentVersionGroupId: $editableDocumentVersionGroupId) {
      editableDocument {
        ...EditableDocumentFragment
      }
    }
  }
`;

export const CONFIRM_EDITABLE_DOCUMENT = gql`
  ${EDITABLE_DOCUMENT_FRAGMENT}
  mutation ConfirmEditableDocument($editableDocumentVersionGroupId: ID!, $version: Int!, $html: String) {
    confirmEditableDocument(
      editableDocumentVersionGroupId: $editableDocumentVersionGroupId
      version: $version
      html: $html
    ) {
      editableDocument {
        ...EditableDocumentFragment
      }
    }
  }
`;

export const UPDATE_EDITABLE_DOCUMENT_LAST_VIEWED_AT = gql`
  ${EDITABLE_DOCUMENT_FRAGMENT}
  mutation UpdateEditableDocumentLastViewedAt($editableDocumentVersionGroupId: ID!) {
    updateEditableDocumentLastViewedAt(editableDocumentVersionGroupId: $editableDocumentVersionGroupId) {
      editableDocument {
        ...EditableDocumentFragment
      }
    }
  }
`;

export const CREATE_EDITABLE_DOCUMENT_IMAGE_ATTACHMENT = gql`
  mutation CreateEditableDocumentImageAttachment($editableDocumentVersionGroupId: ID!, $filename: String!) {
    createEditableDocumentImageAttachment(
      editableDocumentVersionGroupId: $editableDocumentVersionGroupId
      filename: $filename
    ) {
      presignedPostPayload
      djangoFileName
      imageAttachment {
        id
        permanentUrl
      }
    }
  }
`;

export const COMPLETE_EDITABLE_DOCUMENT_IMAGE_UPLOAD = gql`
  mutation CompleteEditableDocumentImageUpload($attachmentId: ID!, $djangoFileName: String!) {
    completeEditableDocumentImageUpload(attachmentId: $attachmentId, djangoFileName: $djangoFileName) {
      success
      imageAttachment {
        id
        permanentUrl
      }
    }
  }
`;

export const CREATE_EDITABLE_DOCUMENT_HTML_PRESIGNED_UPLOAD = gql`
  ${EDITABLE_DOCUMENT_FRAGMENT}
  mutation CreateEditableDocumentHtmlPresignedUpload(
    $editableDocumentVersionGroupId: ID!
    $version: Int!
    $expiresIn: Int
  ) {
    createEditableDocumentHtmlPresignedUpload(
      editableDocumentVersionGroupId: $editableDocumentVersionGroupId
      version: $version
      expiresIn: $expiresIn
    ) {
      presignedPutUrl
      contentType
      djangoFileName
      editableDocument {
        ...EditableDocumentFragment
      }
    }
  }
`;

export const COMPLETE_EDITABLE_DOCUMENT_HTML_UPLOAD = gql`
  ${EDITABLE_DOCUMENT_FRAGMENT}
  mutation CompleteEditableDocumentHtmlUpload($editableDocumentId: ID!, $djangoFileName: String!) {
    completeEditableDocumentHtmlUpload(editableDocumentId: $editableDocumentId, djangoFileName: $djangoFileName) {
      success
      editableDocument {
        ...EditableDocumentFragment
      }
    }
  }
`;
